import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Check, CalendarCheck } from "lucide-react";
import "./Quiz.css";
import "./ThankYou.css";

const BOOKING_URL = "https://calendly.com/sassyfullstackfitness/30min";

const openCalendly = () => {
  window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
};

const ThankYouPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const plan = location.state;

  if (!plan) {
    return (
      <div className="sffx-quiz ty-page">
        <div className="ty-topbar">
          <button className="ty-logo" onClick={() => navigate("/")}>
            Sassy Full Stack Fitness
          </button>
        </div>
        <div className="ty-empty">
          <h1 className="ty-title">No plan yet</h1>
          <p className="q-form-intro">
            Take the 60-second quiz to get your custom 6-week plan.
          </p>
          <button className="q-submit" onClick={() => navigate("/quiz")}>
            Take the Quiz →
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sffx-quiz ty-page">
      <div className="ty-topbar">
        <button className="ty-logo" onClick={() => navigate("/")}>
          Sassy Full Stack Fitness
        </button>
      </div>

      <div className="ty-wrap">
        {/* ===== CONFIRMATION MESSAGE ===== */}
        <div className="ty-head q-step" data-testid="ty-confirmation">
          <div className="ty-check-badge">
            <Check size={26} strokeWidth={3} />
          </div>
          <h1>
            {plan.name ? `${plan.name}, you're` : "You're"} All{" "}
            <span className="gold">Set!</span>
          </h1>
          <p>
            Check your email to receive your free 6-Week Transformation shortly.
            If you don't see it in your inbox, be sure to check your spam folder.
          </p>
        </div>

        {/* ===== BOOK THE CALL (Calendly) ===== */}
        <div className="ty-cal-block">
          <div className="ty-cal-head">
            <h2>Book Your Free Training Plan Implementation Call with Sandra Herself</h2>
            <p>
              Pick a time that works for you and Sandra will personally help you
              put your plan into action.
            </p>
          </div>
          <div className="ty-consult-wrap">
            <button
              type="button"
              className="ty-consult-btn"
              data-testid="book-consultation-btn"
              onClick={openCalendly}
            >
              <span className="ty-consult-title">
                <CalendarCheck size={18} strokeWidth={2.5} /> Book Your Free
                Consultation
              </span>
              <span className="ty-consult-sub">
                30 minutes with Sandra. No obligation. Leave with answers.
              </span>
            </button>
          </div>
        </div>
      </div>

      <footer className="ty-footer">
        <div className="ty-wrap">
          © 2026 Sassy Full Stack Fitness &nbsp;·&nbsp;{" "}
          <a
            href="https://sassyfitness.com/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Privacy Policy
          </a>{" "}
          &nbsp;·&nbsp;{" "}
          <a
            href="https://sassyfitness.com/terms.html"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Terms
          </a>
        </div>
      </footer>
    </div>
  );
};

export default ThankYouPage;
